import React from 'react';
import { connect } from 'react-redux';
import * as owasp from 'owasp-password-strength-test';

// Actions
import { userActions, alertActions } from '../actions';

import Header from '../components/Header';
import HeaderStudent from '../components/HeaderStudent';

class ProfilePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user ? { ...this.props.user } : {},
      pass_errors: [],
    };
    // Bindings
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.logOut = this.logOut.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(alertActions.clear());
  }

  handleChange(e) {
    let user = { ...this.state.user };
    user[e.target.name] = e.target.value;
    this.setState({ user });
    if (e.target.name === 'password') {
      const passTest = owasp.test(e.target.value);
      if (passTest.errors.length)
        this.setState({ pass_errors: passTest.errors });
      else this.setState({ pass_errors: [] });
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    const { dispatch } = this.props;
    const { user } = this.state;
    // Validations
    if (
      user.password &&
      user.password.length > 0 &&
      user.password !== user.repassword
    )
      return this.setState({
        error: 'Password and password confirmation do not match.',
      });
    dispatch(userActions.update(user));
  }

  logOut() {
    const { dispatch } = this.props;
    dispatch(userActions.logout());
  }

  render() {
    const { profile_error } = this.props;
    const { user, error, pass_errors } = this.state;

    let passValidation = '';
    if (user.password && user.password.length > 0)
      passValidation =
        user.password !== user.repassword ? 'is-invalid' : 'is-valid';
    if (profile_error || pass_errors.length) passValidation = 'is-invalid';

    return (
      <div>
        {user.role !== 'student' && <Header />}
        {user.role === 'student' && <HeaderStudent />}

        <div className='row mt-5'>
          <div className='col-12 col-lg-4 offset-lg-4'>
            {error && (
              <div className='alert alert-danger text-center'>{error}</div>
            )}

            <h2 className='fw-light'>Your Profile</h2>
            <hr />

            {profile_error && (
              <div className='alert alert-danger'>{profile_error}</div>
            )}

            <form className='mt-4' onSubmit={this.handleSubmit}>
              <div className='form-group mb-3'>
                <input
                  name='name'
                  className='form-control form-control-lg'
                  placeholder='Name'
                  value={user.name}
                  onChange={this.handleChange}
                />
              </div>
              <div className='form-group mb-3'>
                <input
                  name='lastname'
                  className='form-control form-control-lg'
                  placeholder='Lastname'
                  value={user.lastname}
                  onChange={this.handleChange}
                />
              </div>
              <div className='form-group mb-3'>
                <input
                  className='form-control form-control-lg'
                  placeholder='email'
                  value={user.email}
                  disabled
                />
              </div>
              <div className='form-group mb-3'>
                <input
                  type='password'
                  name='password'
                  className={`form-control form-control-lg ${passValidation}`}
                  onChange={this.handleChange}
                  placeholder='Type your new password'
                />
              </div>
              <div className='form-group mb-3'>
                <input
                  type='password'
                  name='repassword'
                  className={`form-control form-control-lg ${passValidation}`}
                  onChange={this.handleChange}
                  placeholder='Repeat your new password'
                />
              </div>
              {pass_errors.length > 0 && (
                <div className='mb-3'>
                  <p className='mb-0'>
                    <small className='text-danger'>{pass_errors[0]}</small>
                  </p>
                  {/* {pass_errors.map((e) => (
                <p className='mb-0'>
                  <small key={e} className='text-danger'>
                    {e}
                  </small>
                </p>
              ))} */}
                </div>
              )}
              <div className='form-group mb-3'>
                <button className='btn btn-primary btn-lg d-block ms-auto'>
                  Update
                </button>
              </div>
            </form>
            <div className='form-group mt-5 mb-5'>
              <button
                onClick={this.logOut}
                className='btn btn-link text-danger d-block mx-auto'>
                Sign out
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { alert, authentication } = state;
  const { user, profile_error } = authentication;
  return {
    alert,
    user,
    profile_error,
  };
}

export default connect(mapStateToProps)(ProfilePage);
